__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "container-module";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "2.32.1", () => (__webpack_require__.e(84).then(() => (() => (__webpack_require__(3084))))));
			register("@azure/msal-react", "1.5.1", () => (Promise.all([__webpack_require__.e(639), __webpack_require__.e(416), __webpack_require__.e(693)]).then(() => (() => (__webpack_require__(9639))))));
			register("@emotion/react", "11.10.5", () => (Promise.all([__webpack_require__.e(536), __webpack_require__.e(416), __webpack_require__.e(558)]).then(() => (() => (__webpack_require__(2558))))));
			register("@emotion/styled", "11.10.5", () => (Promise.all([__webpack_require__.e(416), __webpack_require__.e(216), __webpack_require__.e(932)]).then(() => (() => (__webpack_require__(932))))));
			register("@microsoft/applicationinsights-react-js", "3.4.0", () => (Promise.all([__webpack_require__.e(627), __webpack_require__.e(416), __webpack_require__.e(839)]).then(() => (() => (__webpack_require__(3147))))));
			register("@microsoft/applicationinsights-web", "2.8.9", () => (Promise.all([__webpack_require__.e(627), __webpack_require__.e(663)]).then(() => (() => (__webpack_require__(6663))))));
			register("@microsoft/microsoft-graph-client", "3.0.4", () => (__webpack_require__.e(789).then(() => (() => (__webpack_require__(1789))))));
			register("@mui/material", "5.10.17", () => (Promise.all([__webpack_require__.e(487), __webpack_require__.e(827), __webpack_require__.e(223), __webpack_require__.e(536), __webpack_require__.e(718), __webpack_require__.e(105), __webpack_require__.e(416), __webpack_require__.e(216), __webpack_require__.e(353), __webpack_require__.e(51)]).then(() => (() => (__webpack_require__(3105))))));
			register("clsx", "1.2.1", () => (__webpack_require__.e(10).then(() => (() => (__webpack_require__(6010))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(3935))))));
			register("react-router-dom", "6.4.5", () => (Promise.all([__webpack_require__.e(818), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(9818))))));
			register("react", "18.2.0", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))));
			initExternal(9228);
			initExternal(5906);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};